const bootstrapIcons = require("bootstrap-icons/bootstrap-icons.svg");
export default bootstrapIcons;
